/* eslint-disable react/prop-types, no-unused-vars */
import { useState, useEffect } from 'react';
import { Modal, Input, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

const SavePipelineDialog = ({
    visible,
    onCancel,
    onSave,
    onSaveAsNew,
    stepCount,
    initialName,
    isExistingPipeline,
    saving,
    title = 'Pipeline',
}) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    useEffect(() => {
        if (visible) {
            setName(initialName || '');
            setDescription('');
        }
    }, [visible, initialName]);

    const handleSave = () => {
        if (!name.trim()) return;
        onSave(name.trim(), description.trim());
    };

    const handleSaveAsNew = () => {
        if (!name.trim()) return;
        onSaveAsNew(name.trim(), description.trim());
    };

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            title={isExistingPipeline ? `Update ${title}` : `Save ${title}`}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={saving} data-testid="pipeline-save-cancel-button">Cancel</Button>,
                ...(isExistingPipeline ? [
                    <Button
                        key="save-as-new"
                        icon={<SaveOutlined />}
                        onClick={handleSaveAsNew}
                        disabled={!name.trim() || saving}
                        loading={saving}
                        data-testid="pipeline-save-as-new-button"
                    >
                        Save as New {title}
                    </Button>,
                ] : []),
                <Button
                    key="save"
                    type="primary"
                    icon={<SaveOutlined />}
                    onClick={handleSave}
                    disabled={!name.trim() || saving}
                    loading={saving}
                    data-testid="pipeline-save-confirm-button"
                    style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                >
                    {isExistingPipeline ? `Update ${title}` : `Save ${title}`}
                </Button>,
            ]}
            centered
            destroyOnHidden
        >
            <div className="flex flex-col gap-4">
                <div>
                    <label className="mb-1 block text-sm font-medium">
                        {title} Name <span className="text-red-500">*</span>
                    </label>
                    <Input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder={title === 'View' ? "e.g., Cleaned Customer View" : "e.g., Clean Customer Data"}
                        maxLength={200}
                        data-testid="pipeline-save-name-input"
                    />
                </div>
                <div>
                    <label className="mb-1 block text-sm font-medium">Description</label>
                    <Input.TextArea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder={`Describe this ${title.toLowerCase()}...`}
                        rows={3}
                        maxLength={500}
                        data-testid="pipeline-save-description-input"
                    />
                </div>
                <div className="rounded bg-gray-50 px-3 py-2 text-sm text-gray-500">
                    <strong>{title} Summary:</strong> {stepCount} transformations configured
                </div>
            </div>
        </Modal>
    );
};

export default SavePipelineDialog;
